import { render, staticRenderFns } from "./ResendVerificationEmail.vue?vue&type=template&id=9f6060ba"
import script from "./ResendVerificationEmail.vue?vue&type=script&lang=js"
export * from "./ResendVerificationEmail.vue?vue&type=script&lang=js"
import style0 from "./ResendVerificationEmail.vue?vue&type=style&index=0&id=9f6060ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports